import React from 'react'

function PhaseComplete(props) {
    const suspectsRemaining = ["x", "x", 6, 5, 4, 3]
    
    const eliminateText = "The suspect has been eliminated from our investigation and now only " + suspectsRemaining[props.nextPage] + " suspects remain. Click the button below to continue."
    
    return (
        <div className="phaseCompleteMessage">
            <h3>{eliminateText}</h3>

            <button className="standardButton" onClick={props.nextPhase}>Click To Continue</button>
        </div>
    )
}

export default PhaseComplete